const KeyIcon = () => {
    return (
        <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Password Icon Grey</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopLanding1024Copy5" transform="translate(-519, -502)" stroke="#999DA0" strokeWidth="2">
                    <g id="PasswordIconGrey" transform="translate(520, 503)">
                        <path d="M19,7.59104574 C19,6.5184249 18.1156574,5.6412 17.0341755,5.6412 L1.96582449,5.6412 C0.884342576,5.6412 0,6.5184249 0,7.59104574 L0,16.6913543 C0,17.7629467 0.884342576,18.6412 1.96582449,18.6412 L17.0341755,18.6412 C18.1156574,18.6412 19,17.7629467 19,16.6913543 L19,7.59104574 Z" id="Stroke1"></path>
                        <path d="M5.1765,5 L5.1765,2.5 C5.1765,1.125 6.17687779,0 7.39939384,0 L10.9551173,0 C12.1761222,0 13.1765,1.125 13.1765,2.5 L13.1765,5" id="Stroke3"></path>
                        <circle id="Oval" cx="9.5" cy="10.5" r="1.5"></circle>
                        <line x1="9.5" y1="12.5" x2="9.5" y2="14.5" id="Line6"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default KeyIcon;
